import PointAndClick from './PointAndClick.js';

import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import Ordi from '../../prefabs/chapitre2/ordi/Ordi.js';
import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import ReponsePopUp from '../../prefabs/global/ordi/ReponsePopUp.js';
import QuestionPanel_1 from '../../prefabs/chapitre2/questions/QuestionPanel_01.js';
import QuestionPanel_2 from '../../prefabs/chapitre2/questions/QuestionPanel_02.js';
import QuestionPanel_3 from '../../prefabs/chapitre2/questions/QuestionPanel_03.js';
import { tags } from '../../consts/Tags.js';
import DebriefPanel from '../../prefabs/chapitre2/DebriefPanel.js';
import SoundManager from '../../prefabs/SoundManager.js';


export default class Chapitre2 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre2"
        })
    }

    init(data){
        this.audioName = 'CafeDeManha';
        super.init(data);   
    }

    create(){
        super.create();

        // Ajout popup d'intro
        this.popupIntro = new PopUpBlue(this, this.width/2, this.height/2, 710, 260)
        this.popupIntro.setAlpha(0);


        let introText = "Le bureau est désert. Le Dr Oliviera est absent. Pourtant, Leïla a été aperçue ici pour la dernière fois. Je vais tenter de trouver des indices sur sa disparition.";
        let popupIntroText = this.add.text(0, 0, introText, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            lineSpacing: 8,
            align: 'center',
            wordWrap: { width: 600 }
        }).setOrigin(0.5, 0);
        this.popupIntro.addElementToBody(popupIntroText, 40);

        let buttonCloseIntro = new ButtonRounded(this, 0, 0,  { 
            text: "Fouiller la pièce",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        });
        this.popupIntro.addButtonToBody(buttonCloseIntro);
        buttonCloseIntro.setClickFunction( () => {
           this.popupIntro.animOut(() => {
                this.popupIntro.destroy(true);
                this.displayButtons();
            });
        })

        this.popupIntro.animIn()
    }

    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "ordinateur"){
            this.openOrdinateur(id, data);
        }
    }

    openOrdinateur(id, data){
        if(this.ordi)
            return

        this.blurBackground();

        // Close ordi si on clique en dehors
        this.background.setInteractive()
        this.background.on('pointerup', () => {
            this.closePopup();
            if(this.ordiPopup)
                this.ordiPopup.animOut(() => {
                    this.ordiPopup.destroy(true);
                    this.ordiPopup = null;
                });
            this.background.disableInteractive();
            this.background.removeListener('pointerup');
        })

        // Ajout ordinateur
        this.ordi = new Ordi(this, this.width/2, this.height)
        this.ordi.setAlpha(0)
        this.ordi.y = this.height - this.ordi.height + 50

        this.ordi.animIn(() => {
            // Change la musique
            this.soundManager.playAudio('DangerAhead')

            // Affiche l'ordi bloqué si besoin
            if(this.ordi.isLocked()){
                this.popupMDP();
            }else{
                // Affiche le panneau de question si l'ordi est débloqué
                this.addQuestionPanel();
            }
        })
    }

    // Popup à l'ouverture de l'ordi quand il est bloqué
    popupMDP(){
        this.ordiPopup = new PopUpBlue(this, 1569, 950, 460, 227)

        let text = "Toutes les réponses se trouvent\ndans le bureau."
        let textElmt = this.add.text(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5, 0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonNext = new ButtonRounded(this, 0, 0, {
            text: "Continuer de fouiller la pièce",
            color: Colors.Elmt.White,
            hoverColor: Colors.Elmt.DarkBlue,
            textColor: Colors.Text.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addButtonToBody(buttonNext)


        this.ordiPopup.animIn()

        buttonNext.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.closePopup();
            })
        })

    }


    // Popup au débloquage de l'ordi, permet de débuter l'enquete ou de retourner à la pièce
    popupStart(){
        // MAJ progression
        this.chapitreProgression.ordi.locked = false;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);

        this.ordiPopup = new PopUpBlue(this, 330, this.height/2, 650, 280)
        
        let textElmt = this.add.text(0, 0, "Voici l’article coécrit par le Dr Oscar Oliviera, pour lequel il a reçu une mystérieuse somme d’argent. Je tiens sûrement une piste.", {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'center',
            lineSpacing: 8,
            wordWrap: { width: 550 }, 
        }).setOrigin(0.5,0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonStart = new ButtonRounded(this, 0, 0, {
            text: "Démarrer l'enquête",
            color: Colors.Elmt.White,
            textColor: Colors.Text.DarkBlue,
            hoverColor: Colors.Elmt.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        buttonStart.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.ordi.unlockButtons()
                this.ordi.showArticle();
                this.addQuestionPanel1();
            })
        })
        this.ordiPopup.addButtonToBody(buttonStart)

        this.ordiPopup.animIn()
    }

    // Appelé par l'ordi quand le code est rentré correctement
    closePopupOrdi(endFunc){
        if(this.ordiPopup == null || this.ordiPopup == undefined) return;

        this.ordiPopup.animOut(() => {
            this.ordiPopup.destroy(true);
            this.ordiPopup = null;
            if(endFunc)
                endFunc();
        })
    }

    addQuestionPanel(){
        const num = this.chapitreProgression.ordi.question
        switch(num){
            case 1:
                this.addQuestionPanel1()
                break;
            case 2:
                this.addQuestionPanel2()
                break;
            case 3:
                this.addQuestionPanel3()
                break;
        }
    }

    // Panneau de question qui s'ouvre une fois l'enquete débutée
    addQuestionPanel1(){
        this.chapitreProgression.ordi.question = 1;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_1(this, 0, 0, {config: this.config.questions[0], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addQuestionPanel2(){
        this.chapitreProgression.ordi.question = 2;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_2(this, 0, 0, {config: this.config.questions[1], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addQuestionPanel3(){
        this.chapitreProgression.ordi.question = 3;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_3(this, 0, 0, {config: this.config.questions[2], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    hidePopUpAide(){
        super.hidePopUpAide();
        if(this.ordi)
            this.ordi.showArticle();
        
    }

    addDebrief(){
        this.debrief = new DebriefPanel(this)
        this.debrief.depth = 100
        this.debrief.animIn();
        this.ordi.hideArticle();
    }

    closeDebrief(){
        this.debrief.destroy(true);

        this.closePopup()
        this.time.addEvent({
            delay: 500,
            callback: () => {
                let txt = 'Vu l’état du bureau, le passage de Leïla n’a pas été de tout repos. Les indices convergent vers une seule hypothèse : un enlèvement orchestré par le Dr Oliviera.\nVendu aux intérêts d’un groupe japonais pour falsifier les données sur la fleur de verre, il semble avoir inclus Leïla dans la transaction. Le traître a sans doute déjà pris la fuite avec son argent.\n\n<class=\"Inter28BoldItalic\">Cap sur le Japon : le secret de cette affaire réside sûrement dans leurs laboratoires.</class>'
                this.popupFinChapitre(txt, 610, "DebutChapitre3");
            }
        })
    }

    closePanelQuestion(endFunc){
        if(this.questionPanel == null || this.questionPanel == undefined) return;

        // Ferme le panneau de question
        this.questionPanel.animOut(() => {
            this.questionPanel.destroy(true);
            this.questionPanel = null;

            if(endFunc)
                endFunc(this);
        })
    }

    // Rectangle Vrai/Faux qui s'affiche après validation de la réponse
    showReponsePopUp({text, isTrue, isLast = false, endFunc}){
        super.showReponsePopUp({text, isTrue, isLast, endFunc});
        this.ordi.hideArticle();
    }

    closeReponsePopUp(){
        super.closeReponsePopUp();
        this.reponsePopup.animOut(()=>{this.ordi.showArticle();})
    }
}